import React, { useState, useEffect } from "react";
import Select from "react-select";
import CityServices from "services/CityServices";

const SelectCity = ({
  selectedStates,
  name,
  label,
  onChange,
  selectedCities,
  setSelectedCities,
  selectedAllCityinState,
}) => {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // If selectedAllCityinState contains values, fetch cities for those states

        if (
          selectedStates &&
          Array.isArray(selectedStates) &&
          selectedStates.length > 0
        ) {
          // Otherwise, fetch cities for selectedStates
          const isStringArray = typeof selectedStates[0] === "string";
          const hasValueKey = selectedStates[0].hasOwnProperty?.("value");

          const stateIds = isStringArray
            ? selectedStates
            : selectedStates
                .map((state) => (hasValueKey ? state.value : null))
                .filter(Boolean);

          const response = await CityServices.getCityByStateId(stateIds);
          // console.log("city id came 1", response);

          const cityList = Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response)
            ? response
            : [];

          setCities(
            cityList?.map((city) => ({
              value: city.id_city,
              label: city.name,
            }))
          );
        }
        if (
          selectedAllCityinState &&
          Array.isArray(selectedAllCityinState) &&
          selectedAllCityinState.length > 0
        ) {
          // const stateIds = selectedAllCityinState.map((state) => state.value);
          const isStringArray = typeof selectedAllCityinState[0] === "string";
          const hasValueKey =
            selectedAllCityinState[0]?.hasOwnProperty?.("value");

          const stateIds = isStringArray
            ? selectedAllCityinState
            : selectedAllCityinState
                .map((state) => (hasValueKey ? state.value : null))
                .filter(Boolean);

          const response = await CityServices.getCityByStateId(stateIds);
          // console.log("came in 2", response);

          const cityList = Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response)
            ? response
            : [];

          const allCities = cityList?.map((city) => ({
            value: city.id_city,
            label: city.name,
          }));

          // Automatically select all cities from these states
          setCities(allCities);
          const allCityIds = allCities.map((city) => city.value);
          // console.log("cityID",allCityIds);

          setSelectedCities(allCityIds); // Update selectedCities with all city IDs
          onChange(allCityIds); // Trigger onChange with all city IDs
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
    // eslint-disable-next-line
  }, [selectedStates, selectedAllCityinState]);

  const handleCitySelect = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setSelectedCities(selectedValues);
    onChange(selectedValues);
  };

  // const getSelectedOptions = () => {
  //   console.log("Selected ---city",selectedCities);
  //   return selectedCities
  //    .map((value) => cities.find((city) => city.value == value))
  //   // .map((value) => cities.find((city) => city.value === Number(value)))

  //     .filter(Boolean);
  // };

  const getSelectedOptions = () => {
    if (!Array.isArray(selectedCities) || selectedCities.length === 0) {
      // console.log("No cities selected");
      return [];
    }

    //console.log("Selected ---city", selectedCities);

    return selectedCities
      .map((value) => cities.find((city) => city.value == value))
      .filter(Boolean);
  };

  const customStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0", // Optional: Adjust padding
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium">{label}</label>}
      <Select
        isMulti
        name={name}
        options={cities}
        value={getSelectedOptions()}
        onChange={handleCitySelect}
        placeholder="--Choose--"
        classNamePrefix="react-select"
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
        styles={customStyles}
      />
    </div>
  );
};

export default SelectCity;
